import { CircleHelp, type LucideIcon } from "lucide-react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { TooltipBorderedArrow } from "@/components/ui/tooltip-bordered-arrow"
import { cn } from "@/lib/utils"

export const HINT_TOOLTIP_CONTENT_CLASS = cn(
  // Выше SelectDropdown menu (z-200)
  "group z-[250] max-w-[16rem] rounded-lg border border-ui-border-opaque bg-ui-bg-elevated px-2.5 py-1.5 text-[11px] leading-relaxed whitespace-pre-line text-ui-text-primary shadow-[var(--ui-shadow-md)]",
  "animate-in fade-in-0 zoom-in-95",
  "data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1",
  "data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1",
)

type Props = {
  label: string
  className?: string
  /** Короткий aria-label; по умолчанию — сам label. */
  ariaLabel?: string
  side?: "top" | "right" | "bottom" | "left"
  icon?: LucideIcon
}

export function FieldHintTooltip({ label, className, ariaLabel, side = "top", icon: Icon = CircleHelp }: Props) {
  return (
    <TooltipPrimitive.Root delayDuration={150}>
      <TooltipPrimitive.Trigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex shrink-0 items-center justify-center rounded-sm leading-none text-ui-text-muted hover:text-ui-text-secondary focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)] focus-visible:outline-none",
            className,
          )}
          aria-label={ariaLabel ?? label}
        >
          <Icon className="block h-3.5 w-3.5" aria-hidden />
        </button>
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content side={side} sideOffset={8} className={HINT_TOOLTIP_CONTENT_CLASS}>
          {label}
          <TooltipBorderedArrow />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
